import { useEffect, useState, useRef } from 'react';
import { Box, Grow } from '@mui/material';

export default function GrowOnScroll(props) {
    const { children } = props;

    // Create a ref to the element that we want to track
    const componentRef = useRef(null);

    // State to track whether the component is in view
    const [inView, setInView] = useState(false);

    // Effect to add a scroll listener when the component mounts
    useEffect(() => {
        const handleScroll = () => {
            const element = componentRef.current;

            // Check if the element is in view
            const rect = element.getBoundingClientRect();
            const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
            const isInView = rect.top <= viewHeight * 0.90 && rect.bottom >= viewHeight * 0.10;

            // Set the inView state if it has changed
            if (isInView !== inView) {
                setInView(isInView);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [inView]);

    return (
        <Box ref={componentRef}>
            <Grow
                in={inView}
                timeout={500}
            >
                <div>
                    {children}
                </div>
            </Grow>
        </Box>
    );
}
